import { AccessControlCheck } from "@/auth/AccessControlCheck";

const CheckAccess = (permission) => {
  return AccessControlCheck.checkPermission(permission);
};

const createAccessCheckPayload = (permission) => {
  return { callback: CheckAccess, value: permission }
}

const items = [
  {
    title: true,
    name: "Lab Settings",
    class: "",
    wrapper: {
      element: "",
      attributes: {},
    },
    access_check: createAccessCheckPayload([
      "list staff",
      "list instrument instance",
      "list test package",
      "list turnaround",
      "list prep workflow",
      "list test workflow",
      "list managed list",
      "list result export",
      "list quality control"
    ]),
  },
  {
    name: "Lab Team",
    url: "/staff",
    icon: "fal fa-users",
    access_check: createAccessCheckPayload("list staff"),
  },
  {
    name: "Lab Instruments",
    url: "/instrument-instances",
    icon: "fal fa-microscope",
    access_check: createAccessCheckPayload("list instrument instance"),
  },
  {
    name: "Test Packages",
    url: "/testpackages",
    icon: "fal fa-shovel",
    access_check: createAccessCheckPayload("list test package"),
  },
  {
    name: "Turnaround Times",
    url: "/turnarounds",
    icon: "fal fa-history",
    access_check: createAccessCheckPayload("list turnaround"),
  },
  {
    name: "Prep Workflows",
    url: "/prep-workflows",
    icon: "fal fa-pencil-ruler",
    access_check: createAccessCheckPayload("list prep workflow"),
  },
  {
    name: "Test Workflows",
    url: "/test-workflows",
    icon: "fal fa-pencil-ruler",
    access_check: createAccessCheckPayload("list test workflow"),
  },
  {
    name: 'Result Export',
    url: '/result-exports',
    icon: 'fal fa-file-excel',
    access_check: createAccessCheckPayload("list result export"),
  },
  {
    name: "Managed Lists",
    url: "/managed-lists",
    icon: "fal fa-microscope",
    access_check: createAccessCheckPayload("list managed list"),
  },
  {
    name: "Quality Control",
    url: "/quality-control",
    icon: "fal fa-pencil",
    access_check: createAccessCheckPayload("list quality control"),
  },
  {
    title: true,
    name: "Global Settings",
    class: "",
    wrapper: {
      element: "",
      attributes: {},
    },
    access_check: createAccessCheckPayload([
      "list laboratory",
      "list analyte",
      "list analysis",
      "list sample type",
      "list instrument",
    ]),
  },
  {
    name: "Manage Laboratories",
    url: "/laboratory",
    icon: "fal fa-building",
    access_check: createAccessCheckPayload("list laboratory"),
  },
  {
    name: "Analytes",
    url: "/analytes",
    icon: "fal fa-eye-dropper",
    access_check: createAccessCheckPayload("list analyte"),
  },
  {
    name: "Analysis",
    url: "/analysis",
    icon: "fal fa-link",
    access_check: createAccessCheckPayload("list analysis"),
  },
  {
    name: "Sample Types",
    url: "/sampletypes",
    icon: "fal fa-tags",
    access_check: createAccessCheckPayload("list sample type"),
  },
  {
    name: "Instrument Definitions",
    url: "/instrument",
    icon: "fal fa-clipboard-list",
    access_check: createAccessCheckPayload("list instrument"),
  },
  {
    name: "Work Groups",
    url: "/workgroups",
    icon: "fal fa-address-book",
    access_check: createAccessCheckPayload("list work group"),
  },
  {
    title: true,
    name: "Developer Tools",
    class: "",
    wrapper: {
      element: "",
      attributes: {},
    },
    access_check: true,
    // access_check: createAccessCheckPayload('list staff')
  },
  {
    name: "API Activity",
    url: "/api-activity",
    icon: "fal fa-calendar-alt",
    access_check: true,
    // access_check: createAccessCheckPayload('list staff')
  },
];

export default {
  items: items.filter(({ access_check }) => access_check),
};
